import BillingsPlanEntryRelatedTaxiTaxiRequest from "../../../../../api/raily/billings/plan-entry/related/taxi-taxi/billings-plan-entry-related-taxi-taxi.request";
import BillingsPlanEntryRelatedTaxiTaxiParams from "./billings-plan-entry-related-taxi-taxi-params";

const create = (
  params: BillingsPlanEntryRelatedTaxiTaxiParams,
): BillingsPlanEntryRelatedTaxiTaxiRequest => {
  return {
    planEntryId: params.planEntryUuid,
  };
};

const billingsPlanEntryRelatedTaxiTaxiParamsFactory = {
  create,
};

export default billingsPlanEntryRelatedTaxiTaxiParamsFactory;
